import { useContext } from "react"
import { useGQL } from "./useGQL.js"
import { GlobalStateContext } from "../components/providers/GlobalStateProvider.jsx"
import { useAuthenticatedFetch } from "./useAuthenticatedFetch.js"

export const useGetThemes = () => {
	const gqlQuery = useGQL()
	const { dispatch } = useContext(GlobalStateContext)
	const authenticatedFetch = useAuthenticatedFetch()

	return async () => {
		const storeThemes = []

		const { data: themesData, errors: themesErrors } = await gqlQuery(`
			query {
				ShopTheme: themes (first: 20) {
					nodes {
						id
						themeStoreId
						name
						role
						createdAt
					}
				}
			}
		`)

		if (themesErrors) {
			console.error("useGetThemes error", themesErrors)
		}

		if (themesData?.ShopTheme?.nodes?.length) {
			const themes = themesData.ShopTheme.nodes
			const activeTheme = themes.find((theme) => theme.role === "MAIN")

			themes.forEach((theme) =>
				storeThemes.push({
					id: theme.id.split("/").pop(),
					themeStoreId: theme.themeStoreId,
					title: theme.name,
					role: theme.role,
					createdAt: theme.createdAt,
					isActive: theme.id === activeTheme.id,
					name: null,
					version: null,
				}),
			)
		}

		const themeIds = storeThemes.map((theme) => theme.id)
		await authenticatedFetch(
			`/api/themes/getThemesInfo?themeIds=${themeIds.join(",")}`,
		)
			.then((res) => res.json())
			.then((json) => {
				if (json?.themesInfo?.length) {
					json.themesInfo.forEach((themeInfo) => {
						const theme = storeThemes.find(
							(theme) => theme.id === themeInfo.themeId,
						)
						if (theme) {
							theme.name = themeInfo.themeName
							theme.version = themeInfo.themeVersion
							theme.author = themeInfo.themeAuthor
							theme.themePalette = themeInfo.themePalette
						}
					})
				}
			})
			.catch((err) => {
				console.error("useGetThemes error", err)
			})

		dispatch({
			storeThemes,
		})
	}
}
